import { useAppContext } from '../../../../../app/Context';

const useTimerCard = () => {
  const { isPresenting } = useAppContext();
  return { isPresenting };
};

export default useTimerCard;
